module.exports = __webpack_public_path__ + "media/images/staffing_levels_explained-952c231f.png";